module.exports = __webpack_public_path__ + "img/dramaFestival_top.5e075f9a.png";